import axios from '@/utils/axios'
import { notify } from '@kyvg/vue3-notification'
import { getUrlBaseV2 } from '@/utils/index'

const getBaseUrl = () => `${getUrlBaseV2()}/chatmix-calls`

function handleError(error, fallback, { silent = false } = {}) {
    if (!silent) {
        const message = error?.response?.data?.message || fallback
        notify({
            type: 'error',
            title: 'Chamada',
            text: message,
        })
    }
    throw error
}

export const chatmixCallsService = {
    /**
     * Cria uma chamada e devolve call_id, agent_token, livekit_url e join_url.
     * @param {number|string} attendanceId
     * @param {string} callType 'audio' | 'video'
     */
    async createCall(attendanceId, callType) {
        try {
            const response = await axios.post(`${getBaseUrl()}/calls`, {
                attendance_id: attendanceId,
                call_type: callType,
            })
            return response.data?.data || response.data
        } catch (error) {
            return handleError(error, 'Não foi possível iniciar a chamada.')
        }
    },

    /**
     * Consulta o status de uma chamada (usado no polling).
     * O polling roda a cada 3s, então falhas aqui não notificam o usuário —
     * apenas registram no console para evitar spam de toasts.
     * @param {string} callId
     */
    async getCallStatus(callId) {
        try {
            const response = await axios.get(`${getBaseUrl()}/calls/${callId}`)
            return response.data?.data || response.data
        } catch (error) {
            return handleError(error, 'Não foi possível consultar a chamada.', { silent: true })
        }
    },

    /**
     * Encerra uma chamada. Idempotente.
     * @param {string} callId
     */
    async endCall(callId) {
        try {
            const response = await axios.post(`${getBaseUrl()}/calls/${callId}/end`)
            return response.data?.data || response.data
        } catch (error) {
            return handleError(error, 'Não foi possível encerrar a chamada.')
        }
    },

    /**
     * Reemite o token do atendente para reconectar na mesma sala.
     * @param {string} callId
     */
    async getAgentToken(callId) {
        try {
            const response = await axios.get(`${getBaseUrl()}/calls/${callId}/agent-token`)
            return response.data?.data || response.data
        } catch (error) {
            return handleError(error, 'Não foi possível reemitir o token da chamada.')
        }
    },
}

export default chatmixCallsService
